module.exports = __webpack_public_path__ + "static/media/sidebar-create-account.2f65834f.svg";